import GridRow from "./component-library28.mjs";
import GridColumn from "./component-library29.mjs";
import Prices from "./component-library32.mjs";
import Heading from "./component-library6.mjs";
import Paragraph from "./component-library5.mjs";
import PictureElement from "./component-library9.mjs";
import "./component-library127.mjs";
import normalizeComponent from "./component-library82.mjs";
const _sfc_main = {
  name: "BannerTeaser",
  components: {
    PictureElement,
    GridColumn,
    GridRow,
    Prices,
    Heading,
    Paragraph
  },
  props: {
    backgroundColor: { type: String, default: "" },
    imageXs: { type: String, default: "" },
    imageSm: { type: String, default: "" },
    imageMd: { type: String, default: "" },
    // Fallback IE11 default
    imageLg: { type: String, default: "" },
    imageXl: { type: String, default: "" },
    alt: { type: String, default: "" },
    lazy: { type: Boolean },
    theme: {
      type: String,
      default: void 0,
      validator(value) {
        return ["light", "dark", "primary", void 0].includes(value);
      }
    },
    isPrice: { type: String, default: "" },
    wasPrice: { type: String, default: "" },
    columnSm: { type: Number, default: 6 },
    columnMd: { type: Number, default: 6 },
    columnLg: { type: Number, default: null },
    columnXl: { type: Number, default: null },
    isContainer: { type: Boolean },
    alignV: {
      type: String,
      default: "center",
      validator(value) {
        return ["center", "end", "start"].includes(value);
      }
    }
  },
  computed: {
    bgColor() {
      return this.backgroundColor ? `background-color: ${this.backgroundColor}` : "";
    },
    classes() {
      const modifier = [];
      modifier.push("banner-teaser");
      if (this.theme)
        modifier.push(`text--${this.theme}`);
      if (this.alignV)
        modifier.push(`banner-teaser--v-align-${this.alignV}`);
      return modifier;
    },
    containerClass() {
      return this.isContainer ? "banner-teaser__container--active" : null;
    },
    hasPrice() {
      return !!(this.isPrice || this.wasPrice);
    }
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("div", { class: _vm.classes, style: _vm.bgColor }, [_c("div", { staticClass: "banner-teaser__background" }, [_vm._t("background", function() {
    return [_c("PictureElement", { attrs: { "src": _vm.imageXs, "src-sm": _vm.imageSm, "src-md": _vm.imageMd, "src-lg": _vm.imageLg, "lazy": _vm.lazy, "alt": _vm.alt } })];
  })], 2), _c("div", { staticClass: "banner-teaser__container", class: _vm.containerClass }, [_c("grid-row", { attrs: { "align-v": "center" } }, [_c("grid-column", { attrs: { "sm": _vm.columnSm, "md": _vm.columnMd, "lg": _vm.columnLg, "xl": _vm.columnXl } }, [_vm.$slots.heading ? _c("heading", { attrs: { "tag": "h3", "size": "md", "text-uppercase": "" } }, [_vm._t("heading")], 2) : _vm._e(), _vm.$slots.paragraph ? _c("paragraph", [_vm._t("paragraph")], 2) : _vm._e(), _vm._t("default"), _vm.hasPrice ? _c("prices", { staticClass: "banner-teaser__prices", attrs: { "is-price": _vm.isPrice, "was-price": _vm.wasPrice } }) : _vm._e(), _vm._t("contentFooter")], 2), _vm.$slots.contentHero ? _c("grid-column", { attrs: { "sm": "", "md": "", "lg": "" } }, [_vm._t("contentHero")], 2) : _vm._e()], 1)], 1)]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "a125133b",
  null,
  null
);
const bannerTeaser = __component__.exports;
export {
  bannerTeaser as default
};
